<script>
import dateFormat from "@/shared/lib/date-format";
import InformationLayout from "@/shared/ui/information-layout/InformationLayout.vue";
import { FormItem, FormLabel, FormControl } from "@/shared/ui/form";
import { Input } from "@/shared/ui/input";
import { SectionHeading } from "@/shared/ui/section-heading";

export default {
  name: "DataRole",
  components: {
    SectionHeading,
    InformationLayout,
    FormItem,
    FormLabel,
    FormControl,
    Input,
  },
  props: {
    form: {
      type: Object,
      default: () => ({}),
    },
    selectedRole: {
      type: Object,
      default: () => null,
    },
  },
  data() {
    return {
      loading: false,
    };
  },
  computed: {
    uuid() {
      return this.$route.params.id;
    },
    showForm() {
      return (
        this.$route.name === "role_new" || this.$route.name === "role_item"
      );
    },
    sections() {
      if (!this.selectedRole) return [];
      return [
        {
          title: this.$t("Данные роли"),
          items: [
            {
              label: this.$t("Наименование роли"),
              values: [
                { lang: "Рус", text: this.selectedRole?.name },
                { lang: "Қаз", text: this.selectedRole?.name_kz },
              ],
            },
            {
              label: this.$t("Дата создания"),
              values: [{ text: this.dateFormat(this.selectedRole.created_at) }],
            },
          ],
        },
      ];
    },
  },
  methods: {
    async validate() {
      return true;
    },
    dateFormat(date) {
      if (!date) {
        return this.$t("Не указано");
      }
      return dateFormat.timestamp_to_local_tz(date, "DD.MM.YYYY, HH:mm");
    },
  },
};
</script>

<template>
  <div class="block">
    <div v-if="showForm" class="flex flex-col gap-6 w-full">
      <!--      <div class="flex flex-col gap-3">-->
      <!--        <div class="text-foreground text-lg font-semibold leading-6">-->
      <!--          {{ $t("Параметры роли") }}-->
      <!--        </div>-->
      <!--        <div class="text-muted-foreground text-sm font-medium leading-5">-->
      <!--          {{ $t("Заполните обязательные поля") }}-->
      <!--        </div>-->
      <!--      </div>-->

      <SectionHeading
        :title="$t('Параметры роли')"
        :description="$t('Заполните обязательные поля')"
      />

      <div class="flex flex-col gap-3">
        <form class="flex flex-col gap-3">
          <div class="grid grid-cols-1 md:grid-cols-2 gap-x-3">
            <FormItem float>
              <FormControl>
                <Input v-model="form.name" placeholder="" />
              </FormControl>
              <FormLabel>{{ $t("Наименование роли (рус)") }}</FormLabel>
            </FormItem>

            <FormItem float>
              <FormControl>
                <Input v-model="form.name_kz" placeholder="" />
              </FormControl>
              <FormLabel>{{ $t("Наименование роли (қаз)") }}</FormLabel>
            </FormItem>

            <FormItem float>
              <FormControl>
                <Input
                  v-model="form.code"
                  @input="form.code = form.code.toLowerCase()"
                  placeholder=""
                />
              </FormControl>
              <FormLabel>{{ $t("Код") }}</FormLabel>
            </FormItem>
          </div>
        </form>
      </div>
    </div>
    <div v-if="$route.name === 'role_item_view'">
      <InformationLayout :showHeader="false" :sections="sections" />
    </div>
  </div>
</template>

<style scoped lang="scss">
.block {
  @apply h-full w-1/2 overflow-auto bg-card rounded-2xl p-8;
}

@media (max-width: 1400px) {
  .block {
    @apply w-full;
  }
}
</style>
